import { Text } from '@betty/moonlight';
import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { formatNumber } from '@betty/toolkit/utils';
import { QuestProgressLabelProps } from './QuestProgressLabel.types';

function QuestProgressLabel({
  currentAccumulation,
  targetAccumulation,
  subPromoType,
}: QuestProgressLabelProps) {
  const { t } = useTranslation('quests');

  const showDecimals = currentAccumulation % 1 !== 0;

  const label =
    subPromoType === 'SpinCount'
      ? t('questSpinsProgress', {
          currentAccumulation: currentAccumulation,
          targetAccumulation: targetAccumulation,
        })
      : subPromoType === 'BetAmount'
        ? t('questSBetProgress', {
            currentAccumulation: formatNumber(currentAccumulation, {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: showDecimals ? 2 : 0,
              maximumFractionDigits: showDecimals ? 2 : 0,
            }),
            targetAccumulation: formatNumber(targetAccumulation, {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 0,
            }),
          })
        : null;

  return label ? (
    <Text variant="caption-semi" color="level_0">
      {label}
    </Text>
  ) : null;
}

export default memo(QuestProgressLabel);
